import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { useUpdateEffect } from 'react-use';

interface QuickSearchState {
  activeItemId: string | null;
  setActiveItem: (activeItemId: string | null) => void;
}

export const useQuickSearchStore = create<QuickSearchState>()(
  immer((set) => ({
    activeItemId: null,
    setActiveItem: (activeItemId) => {
      set(() => ({ activeItemId }));
    },
  }))
);

export const hasActiveItemSelector = ({ activeItemId }: QuickSearchState) => activeItemId !== null;

export const useQuickSearchBarItemCloseEffect = (itemId: string, callback: () => void) => {
  const { activeItemId } = useQuickSearchStore();

  useUpdateEffect(() => {
    if (activeItemId !== itemId) {
      callback();
    }
  }, [activeItemId]);
};
